// extracted by mini-css-extract-plugin
module.exports = {"nav-button":"nav-button___24SJy","nav-prev":"nav-prev___2lEDQ","nav-next":"nav-next___25DTN","btn-circle":"btn-circle___G0z6C"};